<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(95vh - 165px)">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              class="background-trans-style">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      rounded="lg"
                      color="transparent"
                      flat>
                      <v-card-text :class="$vuetify.breakpoint.smAndDown ? 'text-center' : 'text-left'">
                        <div>
                          <h1 class="white--text text-md-h2 mb-5 title-page">{{ $t('header.education') }}</h1>
                          <h2 class="white--text text-md-h4 mb-5">
                            {{ $t('header.tagline') }}
                          </h2>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-10">
      <v-row justify="center" class="black--text">
        <v-col cols="12" md="8" class="text-center" v-if="$i18n.locale === 'en'">
          <h2 class="text-md-h4 font-weight-bold mb-10 text-bg-black text-center">
            <span>Explore Programs Available at PNB</span>
          </h2>
          <h2 class="text-md-h4 font-weight-bold">
            Follow your passion, or discover new ones. Politeknik Negeri Bali offers unparalleled student experiences across a broad spectrum of academic environments. Search or browse for a specific program to learn more about admissions requirements, scholarships, and financial aid opportunities.
          </h2>
        </v-col>
        <v-col cols="12" md="8" class="text-center" v-if="$i18n.locale === 'id'">
          <h2 class="text-md-h4 font-weight-bold mb-10 text-bg-black text-center">
            <span>Jelajahi Program yang Tersedia di PNB</span>
          </h2>
          <h2 class="text-md-h4 font-weight-bold">
            Ikuti hasrat Anda, atau temukan yang baru. Politeknik Negeri Bali menawarkan pengalaman mahasiswa yang tak tertandingi di spektrum yang luas dari lingkungan akademik. Cari atau telusuri program tertentu untuk mempelajari lebih lanjut tentang persyaratan penerimaan, beasiswa, dan peluang bantuan keuangan.
          </h2>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="5">
              <v-img
                :src="require('./../assets/bg-edu.jpg')">
              </v-img>
            </v-col>
            <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
              <!-- <v-divider vertical></v-divider> -->
            </v-col>
            <v-col cols="12" md="6" v-if="$i18n.locale === 'en'">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                Education in PNB
              </h2>
              <p class="text-justify">
                Politeknik Negeri Bali not only carries out an educational mission, but also implements research and social service assignments (community service), by utilizing existing human resources. In particular, PNB is a vocational higher education provider that focuses on developing knowledge and skills in the field of applied science and technology. The target of education is directed at the development of comprehensive intelligent people by prioritizing the development of professional human resources, by providing education based on the needs of the market and industry.
              </p>
            </v-col>
            <v-col cols="12" md="5" v-if="$i18n.locale === 'id'">
              <h2 class="text-md-h4 font-weight-bold mb-5 sub-title-page">
                Pendidikan di PNB
              </h2>
              <p class="text-justify">
                Politeknik Negeri Bali tidak hanya mengemban misi pendidikan, tetapi juga melaksanakan tugas penelitian dan pengabdian masyarakat (pengabdian masyarakat), dengan memanfaatkan sumber daya manusia yang ada. Secara khusus, PNB merupakan penyelenggara pendidikan tinggi vokasi yang berfokus pada pengembangan pengetahuan dan keterampilan di bidang ilmu dan teknologi terapan. Sasaran pendidikan diarahkan pada pengembangan insan cerdas yang komprehensif dengan mengutamakan pengembangan sumber daya manusia yang profesional, dengan menyelenggarakan pendidikan berdasarkan kebutuhan pasar dan industri.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.department') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="$i18n.locale === 'en'">
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/civil-engineering.jpg')">
              <v-card-title>Civil Engineering</v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 2 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>The Department of Civil Engineering at the Politeknik Negeri Bali is one of the six departments organized by the Politeknik Negeri Bali, as a producer of professionals who have international competitiveness in the field of civil engineering.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/mechanical-engineering.jpg')">
              <v-card-title>Mechanical Engineering</v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 3 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>The Mechanical Engineering Department organizes professional education with applied expertise in the fields of machinery and sustainable energy which is supported by science and prioritizes hands on experience (practice) by involving activities in laboratories, workshops and industry.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/electrical.jpg')">
              <v-card-title>Electrical Engineering</v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 4 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>JTE is currently holding the Applied Undergraduate Study Program in Automation Engineering and the D III Electrical Engineering Study Program as well as the D III Information Management Study Program which are very in line with the demands of the digital era and the current and future 4.0 industrial revolution.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/accounting.jpg')">
              <v-card-title>Accounting</v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 3 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>The Department of Accounting, Politeknik Negeri Bali, is still the favorite for high school and vocational high school graduates. Their hope, after completing their studies, is that they want to become professionals in the accounting field and have global competitiveness.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/adinistrasi.jpg')">
              <v-card-title>Business Administration</v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 3 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>The Department of Commerce has a Vision to Become a Leading Vocational Higher Education Institution that Produces Internationally Competitive Professional Graduates by 2025. </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/pariwisata.jpg')">
              <v-card-title>Tourism</v-card-title>
            </v-img>
            <v-card-subtitle>
              Have 4 Study Programs
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>The Politeknik Negeri Bali Tourism Department (PNB) is one of the majors in the field of commerce at the Politeknik Negeri Bali campus.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="$i18n.locale === 'id'">
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/civil-engineering.jpg')">
              <v-card-title>Teknik Sipil</v-card-title>
            </v-img>
            <v-card-subtitle>
              Memiliki 2 Program Studi
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>Jurusan Teknik Sipil Politeknik Negeri Bali adalah salah satu dari enam jurusan yang diselenggarakan oleh Politeknik Negeri Bali, sebagai penghasil tenaga profesional yang memiliki daya saing internasional di bidang teknik sipil.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/mechanical-engineering.jpg')">
              <v-card-title>Teknik Mesin</v-card-title>
            </v-img>
            <v-card-subtitle>
              Memiliki 3 Program Studi
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>Jurusan Teknik Mesin menyelenggarakan pendidikan professional berkeahlian terapan di bidang mesin dan energi berkelanjutan yang didukung oleh keilmuan dan mengedepankan hands on experience (praktek) dengan melibatkan kegiatan di laboratorium, bengkel-kerja dan industri.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/electrical.jpg')">
              <v-card-title>Teknik Elektro</v-card-title>
            </v-img>
            <v-card-subtitle>
              Memiliki 4 Program Studi
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>JTE saat ini menyelenggarakan  Prodi  Sarjana Terapan bidang Teknik Otomasi  dan Prodi D III Teknik Listrik serta Prodi D III Manajemen Informatika yang sangat sesuai dengan tuntutan di  era digital serta revolusi industry 4.0 saat ini maupun masa mendatang.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/accounting.jpg')">
              <v-card-title>Akuntansi</v-card-title>
            </v-img>
            <v-card-subtitle>
              Memiliki 3 Program Studi
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>Jurusan Akuntansi, Politeknik Negeri Bali, sampai saat ini masih terfavorit bagi lulusan SMA maupun SMK. Harapan mereka, setelah menyelesaikan studi ingin menjadi tenaga profesional di bidang akuntansi dan berdaya saing global.</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/adinistrasi.jpg')">
              <v-card-title>Administrasi Niaga</v-card-title>
            </v-img>
            <v-card-subtitle>
              Memiliki 3 Program Studi
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>Jurusan Administrasi Niaga memiliki Visi Menjadi Lembaga Pendidikan Tinggi Vokasi Terdepan Penghasil Lulusan Profesional Berdaya saing Internasional Pada tahun 2025. </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4">
          <v-card
            class="flex-grow-1"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="require('../assets/pariwisata.jpg')">
              <v-card-title>Pariwisata</v-card-title>
            </v-img>
            <v-card-subtitle>
              Memiliki 4 Program Studi
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div>Jurusan Pariwisata Politeknik Negeri Bali (PNB) adalah salah satu jurusan bidang tata niaga yang ada di kampus Politkenik Negeri Bali</div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small>
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container class="my-10">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold sub-title-page">
            {{ $t('title.newsedu') }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="newslist.length">
        <v-col
          class="d-flex" style="flex-direction:column"
          cols="12"
          md="4"
          v-for="(news, i) in newslist"
          :key="i">
          <v-card
            class="mx-auto"
            outlined>
            <v-img
              class="white--text align-end"
              height="200px"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.5)"
              :src="news.urlpic">
              <v-card-title>
                <router-link
                  class="text-decoration-none text-truncate white--text"
                  :title="news.judul_berita"
                  :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                  {{ news.judul_berita }}
                </router-link>
              </v-card-title>
            </v-img>
            <v-card-subtitle>
              <v-chip
                class="mr-1"
                color="deep-orange"
                small
                dark
                :title="news.tgl_berita">
                <v-icon left small>
                  mdi-update
                </v-icon>
                <timeago :datetime="news.tgl_berita"></timeago>
              </v-chip>
              <v-chip
                class="mr-1"
                color="primary"
                small
                dark>
                <v-icon left small>
                  mdi-alpha-c-circle
                </v-icon>
                {{ news.cat_berita }}
              </v-chip>
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <div v-html="news.prev_berita"></div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="mx-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                <v-icon dark>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              <span>{{ $t('button.readmore') }}</span>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark>
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!newslist.length">
        <v-col cols="12" md="12">
          <div class="grey--text my-2">
            Berita pada kategori ini tidak ditemukan.
          </div>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            large
            :color="maincolor"
            dark
            :to="{ name: 'Research' }">
            {{ $t('button.othernews') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Eucation',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    newslist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/bg-edu.jpg'),
      },
    ],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    // this.getJeniskerja();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.updateLanguage();
      }
    },
  },
  methods: {
    updateLanguage() {
      this.getBerita();
    },
    getBerita() {
      this.newslist = [];
      this.paramberita.lang = this.$i18n.locale;
      this.paramberita.limit = 6;
      this.paramberita.type = 'berita';
      this.paramberita.category = 'pendidikan';
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJeniskerja();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
